import { CommonModule, DOCUMENT, isPlatformBrowser, NgClass, NgStyle, registerLocaleData } from "@angular/common";
import es from "@angular/common/locales/es";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, HostListener, Inject, OnDestroy, OnInit, PLATFORM_ID, Renderer2 } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { NavigationEnd, Router, RouterOutlet } from "@angular/router";
import { environment } from "@src/environments/environment";
import { GoogleAnalyticsService } from "ngx-google-analytics";
import { firstValueFrom, Observable, Subscription } from "rxjs";
import { filter } from "rxjs/operators";
import { CookieConsentSubComponent } from "./componentes/cookie-consent/cookie-consent-sub.component";
import { CookieConsentComponent } from "./componentes/cookie-consent/cookie-consent.component";
import { FooterComponent } from "./componentes/footer/footer.component";
import { HeaderComponent } from "./componentes/header/header.component";
import { SafeResourceUrlPipe } from "./pipes/safeResourceUrl/safe-resource-url.pipe";
import { CanonicalService } from "./servicios/canonical/canonical.service";
import { ConfigService } from "./servicios/config/config.service";
import { ConsentService, consentType } from "./servicios/consent/consent.service";
import { DeviceService } from "./servicios/device/device.service";
import { FirebaseService } from "./servicios/firebase.service";
import { FooterService } from "./servicios/footer.service";
import { IframeService } from "./servicios/iframe/iframe.service";
import { NoticiasService } from "./servicios/noticias/noticias.service";
import { PerformanceTrackingService } from "./servicios/PerformanceTrackingService";
import { PlatformService } from "./servicios/platform/platform.service";
import { PortadaService } from "./servicios/portada/portada.service";
import { PublicidadService } from "./servicios/publicidad/publicidad.service";
import { SeoService } from "./servicios/seo/seo.service";
import { SidenavService } from "./servicios/sidenav/sidenav.service";
import { DataLayerService } from "./servicios/publicidad/data-layer.service";
export type consents = {
  init: boolean;
  config: boolean;
  rendimiento: boolean;
  publicidad: boolean;
};

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  imports: [CommonModule, HeaderComponent, NgStyle, NgClass, RouterOutlet, FooterComponent, SafeResourceUrlPipe, CookieConsentSubComponent, CookieConsentComponent],
  providers: [IframeService, SeoService, SidenavService, PortadaService, NoticiasService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit, OnDestroy {
  constantesGlobales: any;
  isShow = true;
  flotante_footer = true;
  analyticCreated = false;
  isInIframe = false;
  navigationSub: Subscription;
  titleSub: Subscription;
  routerSub: Subscription;

  showFooter = true;
  isMobile = false;
  isWebView = false;
  publicidadSubscribe: Subscription;
  publicidadFondoCompleto: any;
  publicidadCabecera: any;

  publicidadIzquierdaExterior: any;
  publicidadIzquierdaExteriorAbajo: any;

  publicidadIzquierdaInterior: any;
  publicidadIzquierdaInteriorAbajo: any;

  publicidadDerechaInterior: any;
  publicidadDerechaInteriorAbajo: any;

  publicidadDerechaExterior: any;
  publicidadDerechaExteriorAbajo: any;

  publicidadFooter: any;
  publicidadFooterMovil: any;

  publicidadInstertsticial: any;
  publicidadInstertsticialMovil: any;

  consentType: consentType = false;
  consents: consents = {
    init: false,
    config: false,
    publicidad: false,
    rendimiento: false,
  };
  consentsSub: Subscription;
  mostrarConsent: boolean = false;
  private cookiesAcceptedFromUrl = false;

  mostrarPublicidadIntersticial = false;
  mostrarPublicidadIntersticialMovil = false;
  temporizadorCierreIntersticial = 0;
  pageReels = false;
  pageNoticia = false;

  private scrollEventFired = false;

  constructor(
    private readonly router: Router,
    private readonly renderer2: Renderer2,
    private readonly iframeService: IframeService,
    private readonly platformService: PlatformService,
    private readonly publicidadService: PublicidadService,
    private readonly noticiasService: NoticiasService,
    private readonly elementRef: ElementRef,
    private readonly seoService: SeoService,
    private readonly configService: ConfigService,
    private readonly consentService: ConsentService,
    private readonly footerService: FooterService,
    private readonly gaService: GoogleAnalyticsService,
    private readonly titleService: Title,
    // private swPush: SwPush,
    private firebaseService: FirebaseService,
    private deviceService: DeviceService,
    @Inject(PLATFORM_ID) private platformId: object,
    private performanceTrackingService: PerformanceTrackingService,
    private readonly canonicalService: CanonicalService,
    private readonly portadaService: PortadaService,
    @Inject(DOCUMENT) private readonly document: any,
    private dataLayerService: DataLayerService,
    private readonly cd: ChangeDetectorRef,
  ) {
    this.constantesGlobales = this.configService.getConstantesGlobales();
    if (isPlatformBrowser(platformId) && this.deviceService.isMobile()) {
      (async () => {
        const isMobile = await firstValueFrom(this.deviceService.isMobile());
        this.deviceService.deviceIsMobile.set(isMobile);
      })();
    }

    registerLocaleData(es);
    if (this.platformService.isBrowser()) {
      // ✅ Inicializar cuenta global (Certificaciones) desde el milisegundo 0
      const w = window as any;
      w.dataLayer = w.dataLayer || [];
      if (!w.gtag) {
        w.gtag = function() {
          w.dataLayer.push(arguments);
        };
      }
      w.gtag("config", "G-G4RC7BX7YM", { send_page_view: false });

      // Verificar si está en un iframe (parámetro URL o ventana)
      const urlParams = new URLSearchParams(window.location.search);
      const isInIframeParam = urlParams.get("inIframe") === "true";

      // Separamos la detección: los webviews NO son iframes para el estilo del header
      this.isWebView = this.isInAndroidWebView() || this.isInIOSWebView();
      this.isMobile = this.deviceService.deviceIsMobile();
      this.isInIframe = window.self !== window.top || isInIframeParam;

      if (this.isInIframe) {
        this.iframeService.setInIframe(true);
        // Solo para iframes reales o forzados por parámetro aplicamos la clase de estilo
        document.body.classList.add("in-iframe-context");
      } else {
        this.iframeService.setInIframe(false);
        document.body.classList.remove("in-iframe-context");
      }
    }

    if (this.platformService.isBrowser()) {
      if (this.constantesGlobales.codigoAdsense) {
        this.setUpAdsense(this.constantesGlobales.codigoAdsense);
      }
    }

    if (this.router?.events) {
      this.navigationSub = this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
        if (!this.consents.init && !this.isInIframe) {
          this.checkRutaCookies();
        }
        if (!this.isShow) {
          this.isShow = true;
        }
        this.seoService.insertaScriptBreadcrumb();
      });
    }

    this.setFooterVisibility();
  }

  /**
   * Método del ciclo de vida de Angular que se llama cuando el componente se destruye.
   * Aquí se desuscriben todas las suscripciones para evitar fugas de memoria.
   *
   * - `this.navigationSub`: Suscripción a la navegación.
   * - `this.titleSub`: Suscripción al título.
   * - `this.consentsSub`: Suscripción a los consentimientos.
   * - `this.publicidadSubscribe`: Suscripción a la publicidad.
   */
  ngOnDestroy(): void {
    if (this.navigationSub) this.navigationSub.unsubscribe();
    if (this.titleSub) this.titleSub.unsubscribe();
    if (this.consentsSub) this.consentsSub.unsubscribe();
    if (this.publicidadSubscribe) this.publicidadSubscribe.unsubscribe();
    if (this.routerSub) this.routerSub.unsubscribe();
  }

  /**
   * Método de ciclo de vida de Angular que se ejecuta al inicializar el componente.
   *
   * - Obtiene la configuración de prensa y ajusta propiedades de estilo basadas en la configuración.
   * - Obtiene los canales de noticias y los establece en el servicio de noticias.
   * - Obtiene los videos más vistos y los establece en el servicio de noticias.
   * - Obtiene las últimas noticias y establece el total en el servicio de noticias.
   * - Actualiza las URLs canónicas.
   * - Obtiene la publicidad de Ispot.
   * - Escucha eventos de navegación y ajusta la propiedad `pageReels` según la URL.
   */
  ngOnInit() {
    if (this.platformService.isBrowser()) {
      // 1. Iniciamos la escucha técnica en el DataLayer
      this.dataLayerService.listenForConsentUpdates();

      // ✅ AHORA SÍ: LLamamos a la sincronización DIRECTAMENTE SIN ESPERAR AL DATALAYER
      // Porque sabemos que Google Funding Choices NO escupe nada al dataLayer para los usuarios antiguos,
      // así que si la dejábamos ahí dentro atrapada, jamás llegaba a ejecutarse para ellos.
      if (this.consents) {
        this.syncWithGoogle();
      }

      // 3. ✅ RECUPERAMOS EL LISTENER EXTERNO (DOM Directo)
      // Lo envolvemos en un listener global para capturar el click en el botón azul de Google
      this.document.addEventListener("click", (event: MouseEvent) => {
        const target = event.target as HTMLElement;
        // 'fc-cta-consent' es la clase del botón "Consentir" de Google
        if (target && (target.classList.contains("fc-cta-consent") || target.closest(".fc-cta-consent"))) {
          //   console.log("🎯 Click detectado en el botón de Google. Forzando accept()...");
          // ✅ Sincronización directa al servicio: pone init en true sin disparar publicidad pesada
          this.consentService.setRendimiento(true);
          this.consentService.saveCookie();
          this.consents = {
            init: true,
            config: false,
            rendimiento: true,
            publicidad: false,
          };

          // ✅ AÑADE ESTO: Notifica a los suscriptores y fuerza el repintado

          this.mostrarConsent = false;
          this.renderer2.setStyle(this.document.body, "overflow", "auto");
          // 5. Forzamos a Angular a repintar YA
          this.cd.markForCheck();
          this.cd.detectChanges();
        }
      });
    }
    const idAmbito = this.constantesGlobales.idAmbito;
    // Escuchar el modal de consentimento de Google (Funding Choices)

    // Verificar si viene el parámetro cookiesAccepted en la URL
    this.checkCookiesFromUrl();

    this.initConfigPrensa();
    this.portadaService.getCanalesApi(idAmbito).catch((error) => console.error("[app] Error loading canales:", error));
    this.loadVideosMasVistos();
    this.loadUltimasNoticias();
    this.updateMetaTags();

    if (!this.isInIframe) {
      this.getPublicidadIspot();
    }
    this.subscribeToNavigationEvents();
  }

  private syncWithGoogle() {
    // Si el consentimiento ya fue aceptado vía URL (iframe), no dejamos que
    // Google TCF lo sobreescriba (porque no puede leer sus cookies en contexto de tercero)
    if (this.cookiesAcceptedFromUrl) return;

    if (this.platformService.isBrowser()) {
      const dataLayer = (window as any).dataLayer || [];

      // ✅ Solución al bug: gtag() inserta "Arguments" (como un Array), no objetos directos.
      // Así que tenemos que buscar dentro de esos arrays/argumentos.
      const hasConsent = dataLayer.some((item) => {
        // Extraer si es array o Arguments
        const isArrayLike = Array.isArray(item) || Object.prototype.toString.call(item) === "[object Arguments]";
        const elementsToCheck = isArrayLike ? Array.from(item) : [item];

        return elementsToCheck.some((arg) => arg && typeof arg === "object" && (arg["analytics_storage"] === "granted" || arg["ad_storage"] === "granted"));
      });

      // ✅ EL GRAN DESCUBRIMIENTO:
      // En lugar de tratar a todos los usuarios antiguos por igual buscando un "granted" invisible
      // en el dataLayer, le preguntamos directamente a la API de privacidad TCF de Google.
      if (typeof (window as any).__tcfapi === "function") {
        (window as any).__tcfapi("addEventListener", 2, (tcData: any, success: boolean) => {
          // Asegurarnos de que el framework de Google ha terminado de cargar ("tcloaded" para antiguos, "useractioncomplete" para nuevos)
          if (success && (tcData.eventStatus === "tcloaded" || tcData.eventStatus === "useractioncomplete")) {
            // Verificamos si el usuario aceptó las cookies (propósito 1 del IAB TCF)
            // Si es true, aceptó. Si es false o no existe, rechazó.
            const accepted = tcData.purpose && tcData.purpose.consents && tcData.purpose.consents[1] === true;

            if (accepted) {
              // ✅ EL USUARIO ACEPTÓ EN EL PASADO (O AHORA)
              // Le aplicamos "el nuevo cambio" (rendimiento encendido, publicidad apagada)
              if (!this.consents.init || this.consents.publicidad === true || this.consents.rendimiento === false) {
                this.consentService.setRendimiento(true);
                this.consentService.setPublicidad(false);
                this.consentService.saveCookie();

                this.consents = {
                  init: true,
                  config: false,
                  rendimiento: true,
                  publicidad: false,
                };
                this.cd.markForCheck();
                this.cd.detectChanges();
              }
            } else {
              // ❌ EL USUARIO RECHAZÓ EL CONSENTIMIENTO EN EL PASADO (O AHORA)
              // Respetamos su rechazo manteniéndolo todo apagado, pero lo registramos validado (init: true)
              // para que la web deje de preguntarle.
              if (!this.consents.init || this.consents.publicidad === true || this.consents.rendimiento === true) {
                this.consentService.setRendimiento(false);
                this.consentService.setPublicidad(false);
                this.consentService.saveCookie();

                this.consents = {
                  init: true,
                  config: false,
                  rendimiento: false,
                  publicidad: false,
                };
                this.cd.markForCheck();
                this.cd.detectChanges();
              }
            }

            // Ya tenemos la respuesta que queríamos, nos desuscribimos de este evento de Google para dejar la memoria limpia
            (window as any).__tcfapi("removeEventListener", 2, (successRemove: boolean) => {
              // listener eliminado
            });
          }
        });
      } else {
        // Fallback por si acaso Google falla o la API no está (muy raro):
        // Reutilizamos el parser que arreglamos antes por si entra el dataLayer mágico.
        const hasConsent = dataLayer.some((item) => {
          const isArrayLike = Array.isArray(item) || Object.prototype.toString.call(item) === "[object Arguments]";
          const elementsToCheck = isArrayLike ? Array.from(item) : [item];

          return elementsToCheck.some((arg) => arg && typeof arg === "object" && (arg["analytics_storage"] === "granted" || arg["ad_storage"] === "granted"));
        });

        if (hasConsent && (!this.consents.init || this.consents.publicidad === true || this.consents.rendimiento === false)) {
          this.consentService.setRendimiento(true);
          this.consentService.setPublicidad(false);
          this.consentService.saveCookie();
          this.consents = { init: true, config: false, rendimiento: true, publicidad: false };
          this.cd.markForCheck();
          this.cd.detectChanges();
        }
      }
    }
  }

  /**
   * Actualiza las metaetiquetas del documento HTML y configura el enlace del feed RSS.
   *
   * - Genera un arreglo de metaetiquetas basado en las constantes globales de la aplicación.
   * - Actualiza las URLs canónicas utilizando el servicio `canonicalService`.
   * - Si la plataforma es un navegador, configura el atributo `href` del enlace RSS.
   *
   * @private
   * @remarks
   * Este método utiliza las constantes globales para establecer valores dinámicos en las metaetiquetas,
   * como el título del sitio, la descripción, la URL, y otros metadatos relevantes para SEO y redes sociales.
   *
   * @throws {Error} Puede lanzar un error si no se encuentra el elemento RSS en el DOM.
   */
  private updateMetaTags() {
    const pathname = this.platformService.getLocationPathname();
    const isHome = !pathname || pathname === "/";

    // Si no estamos en la portada (por ejemplo, estamos en una noticia o sección),
    // no pisamos el canonical ni los metatags específicos que gestiona cada componente de ruta.
    if (!isHome) {
      if (this.platformService.isBrowser()) {
        const rssElement = this.document.querySelector('[type="application/rss+xml"]');
        if (rssElement) {
          rssElement.setAttribute("href", this.constantesGlobales.siteDomain + "/rssfeed");
        }
      }
      return;
    }

    this.seoService.updateGenericMetaTags({
      title: this.constantesGlobales.siteTitle,
      description: this.constantesGlobales.metaTag,
      url: this.constantesGlobales.siteDomain,
      type: "website",
    });

    const tituloActual = this.titleService.getTitle();
    if (!tituloActual?.trim()) {
      this.titleService.setTitle(this.constantesGlobales.siteTitle);
    }

    if (this.platformService.isBrowser()) {
      const rssElement = this.document.querySelector('[type="application/rss+xml"]');
      if (rssElement) {
        rssElement.setAttribute("href", this.constantesGlobales.siteDomain + "/rssfeed");
      }
    }
  }

  private initConfigPrensa(): void {
    const configPrensa = this.configService.getConfigPrensa();
    if (configPrensa) {
      this.handleConfigPrensa(configPrensa);
    }
  }

  private async handleConfigPrensa(configPrensa: Observable<any>): Promise<void> {
    const result = await firstValueFrom(configPrensa);
    this.flotante_footer = result.general["global-constants"].flotante_footer === "true";
    this.setRoundBorder(result.general["global-constants"]);
  }

  private setRoundBorder(constants: any): void {
    if (constants.round_border === "true" && constants.round_border_radius) {
      this.elementRef.nativeElement.style.setProperty("--round-noticias", `${constants.round_border_radius}px`);
    }
  }

  private loadVideosMasVistos(): void {
    const idAmbito = this.constantesGlobales.idAmbito;
    const mostWatchVideos = this.noticiasService.getVideosMasVistosApi(10, idAmbito);
    if (mostWatchVideos) {
      this.handleVideosMasVistos(mostWatchVideos);
    }
  }

  private async handleVideosMasVistos(videos: Observable<any>): Promise<void> {
    try {
      const result = await firstValueFrom(videos);
      this.noticiasService.setVideosMasVistos(result);
    } catch (error) {
      console.error("[app] Error loading videos mas vistos:", error);
    }
  }

  private loadUltimasNoticias(): void {
    const idAmbito = this.constantesGlobales.idAmbito;
    const lastNews = this.noticiasService.getUltimasNoticias(10, null, null, idAmbito);
    if (lastNews) {
      this.handleUltimasNoticias(lastNews);
    }
  }

  private async handleUltimasNoticias(noticias: Observable<any>): Promise<void> {
    try {
      const data = await firstValueFrom(noticias);
      this.noticiasService.setTotalUltimasNoticias(data);
    } catch (error) {
      console.error("[app] Error loading ultimas noticias:", error);
    }
  }

  private subscribeToNavigationEvents(): void {
    if (this.router?.events) {
      this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
        this.pageReels = event.url.includes("/reels");
        this.pageNoticia = event.url.includes("/noticias/");
      });
    }
  }

  requestPushNotifications() {
    if (Notification.permission === "default") {
      // Si el permiso es "default", significa que aún no se ha solicitado
      this.firebaseService.requestPermissionAndSubscribe("noticias");
    } else if (Notification.permission === "granted") {
      //console.log("Permiso de notificaciones ya concedido");
      // Aquí puedes continuar con la lógica que necesite el permiso
    } else {
      // console.warn("Permiso de notificaciones denegado");
      // Aquí puedes ofrecer al usuario una forma de cambiar la configuración manualmente si lo deseas
    }
  }

  /**
   * Suscribirse a las notificaciones push
   */
  // subscribeToPush(): void {
  //   // Usamos el observable `swPush.notification` para recibir mensajes
  //   this.swPush.messages.subscribe({
  //     next: (message: any) => {
  //       console.log(message, "Message to show in the notification");
  //       // Aquí podrías mostrar la notificación o procesar el mensaje como prefieras
  //     },
  //     error: (error: any) => {
  //       console.error("Error al recibir el mensaje push", error);
  //       // Puedes manejar el error de suscripción a push aquí
  //     },
  //     complete: () => {
  //       console.log("Suscripción a notificaciones completada");
  //       // Opcional: Aquí puedes realizar acciones adicionales cuando se complete la suscripción
  //     },
  //   });
  // }

  /**
   * Configura el script de Adsense con el ID de analítica proporcionado.
   *
   * @param idAnalytic - El ID de analítica que se utilizará para configurar el script de Adsense.
   * @returns void
   */
  setUpAdsense(idAnalytic): void {
    const scriptElement = this.renderer2.createElement("script");
    scriptElement.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=" + idAnalytic;
    scriptElement.crossOrigin = "anonymous";
  }

  /**
   * Establece la visibilidad del pie de página.
   *
   * Este método suscribe al observable `getShowFooter` del servicio `footerService`
   * y actualiza la propiedad `showFooter` con el valor emitido por el observable.
   *
   * @returns {void}
   */
  setFooterVisibility(): void {
    this.footerService.getShowFooter().subscribe((isShow) => {
      this.showFooter = isShow;
    });
  }
  /**
   * Obtiene y asigna la publicidad para diferentes posiciones en la aplicación.
   *
   * Este método suscribe a un servicio de publicidad para obtener un conjunto de imágenes publicitarias.
   * Filtra las imágenes según su posición y asigna una imagen aleatoria a cada posición específica.
   * Además, gestiona la visualización de publicidad intersticial y su temporizador de cierre.
   *
   * @returns {void}
   */
  getPublicidadIspot(): void {
    this.publicidadSubscribe = this.publicidadService.getPubli().subscribe((result) => {
      const publicidadFondoCompleto = result.imagenes.filter((item) => item.idPosicion === "53");
      let numPubli = Math.floor(Math.random() * publicidadFondoCompleto.length);
      this.publicidadFondoCompleto = publicidadFondoCompleto[numPubli];
      if (!this.publicidadFondoCompleto) {
        const arrayPublicidadCabecera = result.imagenes.filter((item) => item.idPosicion === "1");
        numPubli = Math.floor(Math.random() * arrayPublicidadCabecera.length);
        this.publicidadCabecera = arrayPublicidadCabecera[numPubli];
        //ARRIBA
        const arrayPublicidadIzquierdaExterior = result.imagenes.filter((item) => item.idPosicion === "17"); // lateral abajo
        numPubli = Math.floor(Math.random() * arrayPublicidadIzquierdaExterior.length);
        this.publicidadIzquierdaExterior = arrayPublicidadIzquierdaExterior[numPubli];

        const arrayPublicidadIzquierdaInterior = result.imagenes.filter((item) => item.idPosicion === "63");
        numPubli = Math.floor(Math.random() * arrayPublicidadIzquierdaInterior.length);
        this.publicidadIzquierdaInterior = arrayPublicidadIzquierdaInterior[numPubli];

        const arrayPublicidadDerechaExterior = result.imagenes.filter((item) => item.idPosicion === "2");
        numPubli = Math.floor(Math.random() * arrayPublicidadDerechaExterior.length);
        this.publicidadDerechaExterior = arrayPublicidadDerechaExterior[numPubli];

        const arrayPublicidadDerechaInterior = result.imagenes.filter((item) => item.idPosicion === "61");
        numPubli = Math.floor(Math.random() * arrayPublicidadDerechaInterior.length);
        this.publicidadDerechaInterior = arrayPublicidadDerechaInterior[numPubli];

        //ABAJO
        const arrayPublicidadIzquierdaExteriorAbajo = result.imagenes.filter((item) => item.idPosicion === "26"); // lateral abajo
        numPubli = Math.floor(Math.random() * arrayPublicidadIzquierdaExteriorAbajo.length);
        this.publicidadIzquierdaExteriorAbajo = arrayPublicidadIzquierdaExteriorAbajo[numPubli];

        const arrayPublicidadIzquierdaInteriorAbajo = result.imagenes.filter((item) => item.idPosicion === "64"); // lateral abajo
        numPubli = Math.floor(Math.random() * arrayPublicidadIzquierdaInteriorAbajo.length);
        this.publicidadIzquierdaInteriorAbajo = arrayPublicidadIzquierdaInteriorAbajo[numPubli];

        const arrayPublicidadDerechaExteriorAbajo = result.imagenes.filter((item) => item.idPosicion === "25");
        numPubli = Math.floor(Math.random() * arrayPublicidadDerechaExteriorAbajo.length);
        this.publicidadDerechaExteriorAbajo = arrayPublicidadDerechaExteriorAbajo[numPubli];

        const arrayPublicidadDerechaInteriorAbajo = result.imagenes.filter((item) => item.idPosicion === "62");
        numPubli = Math.floor(Math.random() * arrayPublicidadDerechaInteriorAbajo.length);
        this.publicidadDerechaInteriorAbajo = arrayPublicidadDerechaInteriorAbajo[numPubli];
      }

      const arrayPublicidadFooter = result.imagenes.filter((item) => item.idPosicion == 5); // footer
      numPubli = Math.floor(Math.random() * arrayPublicidadFooter.length);
      this.publicidadFooter = arrayPublicidadFooter[numPubli];

      const arrayPublicidadFooterMovil = result.imagenes.filter((item) => item.idPosicion === "32"); // footer movil
      numPubli = Math.floor(Math.random() * arrayPublicidadFooterMovil.length);
      this.publicidadFooterMovil = arrayPublicidadFooterMovil[numPubli];

      const arrayPublicidadInstertsticial = result.imagenes.filter((item) => item.idPosicion == 54);
      numPubli = Math.floor(Math.random() * arrayPublicidadInstertsticial.length);
      this.publicidadInstertsticial = arrayPublicidadInstertsticial[numPubli];

      const arrayPublicidadInstertsticialMovil = result.imagenes.filter((item) => item.idPosicion == 30);
      numPubli = Math.floor(Math.random() * arrayPublicidadInstertsticialMovil.length);
      this.publicidadInstertsticialMovil = arrayPublicidadInstertsticialMovil[numPubli];

      const hasValidInstertsticial = this.publicidadInstertsticial && ((this.publicidadInstertsticial.img && this.publicidadInstertsticial.img !== "null") || this.publicidadInstertsticial.esIframe == 1);
      const hasValidInstertsticialMovil = this.publicidadInstertsticialMovil && ((this.publicidadInstertsticialMovil.img && this.publicidadInstertsticialMovil.img !== "null") || this.publicidadInstertsticialMovil.esIframe == 1);

      if ((hasValidInstertsticial || hasValidInstertsticialMovil) && !this.isInIframe) {
        this.mostrarPublicidadIntersticial = true;
        this.mostrarPublicidadIntersticialMovil = true;
        this.temporizadorCierreIntersticial = 5;
        let interval;
        if (this.platformService.isBrowser()) {
          interval = setInterval(() => {
            this.temporizadorCierreIntersticial -= 1;
            if (this.temporizadorCierreIntersticial == 0) {
              this.mostrarPublicidadIntersticial = false;
              this.mostrarPublicidadIntersticialMovil = false;
              clearInterval(interval);
            }
          }, 1000);
        }
        this.router.events.subscribe((event) => {
          if (event instanceof NavigationEnd) {
            this.mostrarPublicidadIntersticial = true;
            this.mostrarPublicidadIntersticialMovil = true;
            this.temporizadorCierreIntersticial = 5;
            if (this.platformService.isBrowser()) {
              interval = setInterval(() => {
                this.temporizadorCierreIntersticial -= 1;
                if (this.temporizadorCierreIntersticial == 0) {
                  this.mostrarPublicidadIntersticial = false;
                  this.mostrarPublicidadIntersticialMovil = false;
                  clearInterval(interval);
                }
              }, 1000);
            }
          }
        });
      }
    });
  }

  /**
   * Método del ciclo de vida de Angular que se llama después de que la vista del componente ha sido inicializada.
   *
   * Este método suscribe al observable `consentType` del servicio `consentService` y realiza diferentes acciones
   * basadas en el tipo de consentimiento recibido. Si el tipo de consentimiento es `false`, inicializa la publicidad.
   *
   * Si el tipo de consentimiento no es `false`, se suscribe al observable `consents` del servicio `consentService`
   * y actualiza los consentimientos. Si los consentimientos no están inicializados y la plataforma es un navegador,
   * establece el estilo `overflow: hidden` en el cuerpo del documento.
   *
   * @returns {void}
   */
  ngAfterViewInit(): void {
    if (this.consentService.consentType) {
      (async () => {
        const consentType = (await firstValueFrom(this.consentService.consentType)) as consentType;
        this.consentType = consentType;
        if (this.platformService.isBrowser()) {
          if (consentType === false) {
            this.refrescoPublicidad();
            // this.consentService.initPublicidad();
            // this.consentService.initRendimiento();
            return;
          }

          this.consentsSub = this.consentService.consents.subscribe((consents: consents) => {
            // ✅ Solo actualizamos si no hemos forzado ya el init en este componente
            if (this.consents.init === false || consents.init === true) {
              this.consents = consents;
              if (this.platformService.isBrowser() && consents.init === false && !this.isInIframe) {
                this.renderer2.setStyle(this.document.body, "overflow", "hidden");
              }
              this.cd.markForCheck(); // Notificar cambio
            }
          });
        }
      })();
    }

    if (this.platformService.isBrowser() && environment.production) {
      setTimeout(() => {
        const metrics = this.performanceTrackingService.getPerformanceMetrics();
        console.log("metrics", metrics);
        this.performanceTrackingService.sendPerformanceMetrics(metrics);
      }, 1000);
    }
  }

  /**
   * Detiene la síntesis de texto a voz (TTS) si se está ejecutando en un navegador.
   *
   * @remarks
   * Esta función verifica si la aplicación se está ejecutando en un entorno de navegador
   * y si la API de síntesis de voz del navegador está disponible. Si ambas condiciones
   * se cumplen, cancela cualquier síntesis de voz en curso.
   *
   * @returns {void} No retorna ningún valor.
   */
  stopTTS(): void {
    if (this.platformService.isBrowser()) {
      if (window.speechSynthesis) {
        window.speechSynthesis.cancel();
      }
    }
  }

  /**
   * Oculta la característica estableciendo la propiedad `isShow` a `false`.
   *
   * @returns {void}
   */
  featureHide(): void {
    this.isShow = false;
  }

  /**
   * Cierra la publicidad intersticial tanto en la versión de escritorio como en la versión móvil.
   * Establece las propiedades `mostrarPublicidadIntersticial` y `mostrarPublicidadIntersticialMovil` a `false`.
   */
  cerrarPublicidadIntersticial(): void {
    this.mostrarPublicidadIntersticial = false;
    this.mostrarPublicidadIntersticialMovil = false;
  }

  /**
   * Acepta los datos del evento y actualiza las configuraciones de consentimiento.
   *
   * @param eventData - Datos del evento opcionales que contienen las configuraciones de consentimiento.
   *
   * Si `eventData` está presente:
   * - Si `eventData` no tiene cambios y `this.consents.config` está configurado, desactiva la configuración de consentimiento.
   * - Actualiza las configuraciones de publicidad y rendimiento basadas en `eventData`.
   * - Si las configuraciones previas de publicidad o rendimiento estaban activadas y ahora están desactivadas, recarga la página.
   *
   * Si `eventData` no está presente:
   * - Activa las configuraciones de publicidad y rendimiento por defecto.
   *
   * Finalmente, guarda las configuraciones de consentimiento en una cookie.
   */
  accept(eventData?: any) {
    if (eventData) {
      if (!eventData.changes && this.consents.config) {
        this.consentService.setConfig(false);
        if (this.platformService.isBrowser()) {
          this.renderer2.setStyle(this.document.body, "overflow", "auto");
        }
        return;
      }
      const prePublicidad = this.consentService.prePubli;
      const preRendimiento = this.consentService.preAnalytics;
      this.consentService.setPublicidad(eventData.publicidad);
      this.consentService.setRendimiento(eventData.rendimiento);
      if ((prePublicidad && !eventData.publicidad) || (preRendimiento && !eventData.rendimiento)) {
        if (this.platformService.isBrowser()) {
          window.location.reload();
        }
      }
    } else {
      this.consentService.setPublicidad(true);
      this.consentService.setRendimiento(true);
    }
    // console.log("Guardando cookie con consentimientos:");
    this.consentService.saveCookie();
  }

  /**
   * La función guarda una cookie con los consentimientos rechazados.
   */
  reject() {
    this.consentService.saveCookie();
  }

  /**
   * La función reconfigura las cookies estableciendo la configuración de consentimiento en verdadero y
   * ocultando el desbordamiento del cuerpo.
   */
  reconfigureCookies() {
    this.consentService.setConfig(true);
    if (this.platformService.isBrowser()) {
      this.renderer2.setStyle(this.document.body, "overflow", "hidden");
    }
  }

  /**
   * La función comprueba si la ruta actual es '/politica-cookies' y establece la variable
   * 'mostrarConsent' en consecuencia.
   * @returns Si la ruta actual es '/politica-cookies', la función no devolverá nada. De lo contrario,
   * devolverá verdadero.
   */
  checkRutaCookies() {
    if (this.platformService.isBrowser()) {
      if (this.router.url === "/politica-cookies") {
        this.renderer2.setStyle(this.document.body, "overflow", "auto");
        this.mostrarConsent = false;
        return;
      }

      this.mostrarConsent = !this.isInIframe;
    }
  }

  /**
   * Verifica si viene el parámetro cookiesAccepted en la URL y acepta automáticamente las cookies
   */
  private checkCookiesFromUrl() {
    if (this.platformService.isBrowser()) {
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.get("cookiesAccepted") === "true") {
        // Marcar que el consentimiento viene por URL (iframe) para evitar que syncWithGoogle lo pise
        this.cookiesAcceptedFromUrl = true;

        // Notificar a Google Consent Mode v2 que hay consentimiento explícito
        const w = window as any;
        w.dataLayer = w.dataLayer || [];
        function gtag() {
          w.dataLayer.push(arguments);
        }
        // @ts-ignore
        gtag("consent", "update", {
          analytics_storage: "granted",
          ad_storage: "granted",
          ad_user_data: "granted",
          ad_personalization: "granted",
        });

        // Aceptar cookies automáticamente sin mostrar el banner
        this.accept({
          config: false,
          init: true,
          publicidad: true,
          rendimiento: true,
        });
        this.mostrarConsent = false;
      }
    }
  }

  /**
   * Maneja el evento de desplazamiento de la ventana.
   * Calcula el porcentaje de desplazamiento de la página y envía un evento a Google Analytics
   * cuando se alcanza el 10% de desplazamiento.
   *
   * @remarks
   * - Utiliza `window.pageYOffset` o `document.documentElement.scrollTop` para obtener la posición de desplazamiento vertical.
   * - Calcula la altura del documento restando la altura de la ventana de la altura total del documento.
   * - Evita divisiones por cero si la página es muy corta.
   * - Envía un evento a Google Analytics usando `ngx-google-analytics` cuando se alcanza el 10% de desplazamiento.
   *
   * @returns {void}
   */
  @HostListener("window:scroll", ["$event"])
  onWindowScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const docHeight = document.documentElement.scrollHeight - window.innerHeight;
    if (docHeight <= 0) {
      // Evita divisiones por cero  si la página es muy corta
      return;
    }

    const scrollPercent = (scrollTop / docHeight) * 100;

    if (!this.scrollEventFired && scrollPercent >= 1) {
      this.scrollEventFired = true;
      // Envía evento a Google Analytics con ngx-google-analytics
      this.gaService.event("scrollDepth", "scroll", "1% Alcanzado");
    }
  }

  /**
   * Método que se suscribe a los eventos de navegación del router y refresca los anuncios publicitarios
   * cuando se detecta una navegación finalizada.
   *
   * @remarks
   * Este método verifica si la plataforma es un navegador y si el objeto `googletag` está disponible
   * y tiene anuncios publicitarios configurados. Si es así, utiliza el comando `googletag.cmd.push`
   * para refrescar los anuncios publicitarios.
   *
   * @returns {void}
   */
  refrescoPublicidad() {
    if (this.router?.events) {
      this.routerSub = this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
        if (this.platformService.isBrowser()) {
          if (window.hasOwnProperty("googletag") && window["googletag"].pubads) {
            window["googletag"].cmd.push(() => {
              window["googletag"].pubads().refresh();
            });
          }
        }
      });
    }
  }

  /**
   * Determines whether the right sky advertisement should be rendered.
   *
   * @returns {boolean} `true` if the application is not running inside an iframe
   * and either `publicidadDerecha` or `publicidadDerechaAbajo` is true; otherwise, `false`.
   */
  get shouldRenderRightSky(): boolean {
    return !this.isInIframe && (this.publicidadDerechaExterior || this.publicidadDerechaExteriorAbajo || this.publicidadDerechaInterior || this.publicidadDerechaInteriorAbajo);
  }

  isInAndroidWebView(): boolean {
    if (isPlatformBrowser(this.platformId)) {
      const userAgent = window.navigator.userAgent.toLowerCase();
      return /; wv/.test(userAgent);
    }
  }
  isInIOSWebView(): boolean {
    if (isPlatformBrowser(this.platformId)) {
      const userAgent = window.navigator.userAgent.toLowerCase();

      const isIOS = /iphone|ipod|ipad/.test(userAgent);
      const notSafari = !/safari/.test(userAgent);
      const notStandalone = !("standalone" in window.navigator && window.navigator["standalone"]);

      return isIOS && notSafari && notStandalone;
    }
  }
}
